import { useState } from "react";
import { toast } from "sonner";

export const useFeedbackAdmin = (authFetch) => {
  const [feedbacks, setFeedbacks] = useState([]);
  const [editingFb, setEditingFb] = useState(null);
  const [fbEditForm, setFbEditForm] = useState({ name: "", message: "" });

  const patch = async (id, body, okMsg, errMsg) => {
    try {
      const res = await authFetch(`/admin/feedback/${id}`, { method: "PUT", body: JSON.stringify(body) });
      if (!res.ok) throw new Error();
      const updated = await res.json();
      setFeedbacks((fb) => fb.map((x) => (x.id === updated.id ? updated : x)));
      if (okMsg) toast.success(okMsg);
      return true;
    } catch {
      toast.error(errMsg);
      return false;
    }
  };

  const deleteFeedback = async (id) => {
    if (!window.confirm("Delete this feedback?")) return;
    try {
      const res = await authFetch(`/admin/feedback/${id}`, { method: "DELETE" });
      if (!res.ok) throw new Error();
      setFeedbacks((fb) => fb.filter((x) => x.id !== id));
      toast.success("Feedback deleted");
    } catch {
      toast.error("Delete failed");
    }
  };

  const toggleFeedbackVisible = (f) => patch(f.id, { visible: !(f.visible !== false) }, null, "Update failed");
  const approveFeedback = (f) => patch(f.id, { approved: true }, "Feedback approved & now public", "Approve failed");
  const startEditFb = (f) => { setEditingFb(f); setFbEditForm({ name: f.name || "", message: f.message || "" }); };
  const saveEditFb = async (e) => {
    e.preventDefault();
    if (await patch(editingFb.id, fbEditForm, "Feedback updated", "Update failed")) setEditingFb(null);
  };

  return { feedbacks, setFeedbacks, deleteFeedback, toggleFeedbackVisible, approveFeedback, editingFb, setEditingFb, fbEditForm, setFbEditForm, startEditFb, saveEditFb };
};
